/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_MimetypeInputs */

const en__field_mimetype = /** @type {(inputs: _Field_MimetypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mimetype`)
};

const de__field_mimetype = /** @type {(inputs: _Field_MimetypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mimetype`)
};

/**
* | output |
* | --- |
* | "Mimetype" |
*
* @param {_Field_MimetypeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_mimetype = /** @type {((inputs?: _Field_MimetypeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_MimetypeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_mimetype(inputs)
	return de__field_mimetype(inputs)
});